'use strict';

function isPasswordField(key) {
    return /password|secret|credential/i.test(key || '');
}

function genericFieldDescription(description) {
    if (typeof description !== 'string' || !/1password/i.test(description)) {
        return description;
    }

    return description
        .replace(/^1Password fields?:[^.]*\.\s*/i, '')
        .replace(/\s*Rocket (stores|sends|combines)[^.]*\.\s*$/i, '')
        .trim();
}

function normalizeCredentialField(field) {
    if (typeof field === 'string') {
        return {
            key: field,
            type: 'input',
            templateOptions: {
                label: field,
                type: isPasswordField(field) ? 'password' : 'text',
                required: true,
            },
        };
    }

    var templateOptions = {};
    Object.keys(field.templateOptions || {}).forEach(function (key) {
        templateOptions[key] = field.templateOptions[key];
    });
    var sourceKey = templateOptions.onePasswordKey;
    var hasStorageSpecificCopy = sourceKey || /1password/i.test(templateOptions.description || '');
    delete templateOptions.onePasswordKey;
    if (!templateOptions.label) {
        templateOptions.label = field.key;
    } else if (hasStorageSpecificCopy) {
        templateOptions.label = templateOptions.label.replace(/^[^—]+—\s*/, '');
    }
    if (templateOptions.description) {
        templateOptions.description = genericFieldDescription(templateOptions.description);
        if (!templateOptions.description) {
            delete templateOptions.description;
        }
    }
    if (!templateOptions.type) {
        templateOptions.type = isPasswordField(field.key) ? 'password' : 'text';
    }
    if (typeof templateOptions.required === 'undefined') {
        templateOptions.required = true;
    }

    return {
        key: sourceKey || field.key,
        type: field.type || 'input',
        templateOptions: templateOptions,
    };
}

function buildTypedCredentialFields(credentialFields) {
    return (credentialFields || []).filter(Boolean).reduce(function (fields, field) {
        var sourceFields = typeof field === 'object' && field.templateOptions &&
            field.templateOptions.onePasswordFields;
        if (Array.isArray(sourceFields)) {
            return fields.concat(sourceFields.map(normalizeCredentialField));
        }
        fields.push(normalizeCredentialField(field));
        return fields;
    }, []);
}

function buildSaveTypedCredentialsPayload(integrationTemplateId, model) {
    var payload = {
        integrationTemplateId: integrationTemplateId,
    };

    Object.keys(model || {}).forEach(function (key) {
        payload[key] = model[key];
    });

    return payload;
}

function buildProviderCredentials(provider, model) {
    model = model || {};
    if (provider === 'achievers') {
        return {
            programUrl: typeof model.base_url === 'undefined' ? model.programUrl : model.base_url,
            clientId: typeof model.username === 'undefined' ? model.clientId : model.username,
            clientSecret: typeof model.credential === 'undefined' ? model.clientSecret : model.credential,
        };
    }
    if (provider === 'workday') {
        var sourceFieldsSupplied = typeof model.hostname !== 'undefined' || typeof model.tenant !== 'undefined';
        var rawHostname = String(model.hostname || '').trim();
        var hostname = rawHostname.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
        var tenant = String(model.tenant || '').trim().replace(/^\/+|\/+$/g, '');
        // A Workday SOAP endpoint carries the tenant in the MIDDLE of the path
        // (/ccx/service/<tenant>/Recruiting/<version>), not at the end. Appending
        // the tenant to a full service path yields .../Recruiting/v46.1/just,
        // which Workday rejects ("Unrecognized service definition for path").
        // When the host field already carries the service path, it is complete —
        // use it as-is and leave the tenant field for display and the @tenant
        // cross-check.
        var hasServicePath = /\/ccx\/service\//i.test(hostname);
        var combinedUrl = hasServicePath ? 'https://' + hostname : 'https://' + hostname + '/' + tenant;
        return {
            workdayUrl: sourceFieldsSupplied ? combinedUrl : model.workdayUrl,
            username: model.username,
            password: typeof model.credential === 'undefined' ? model.password : model.credential,
        };
    }
    return model;
}

function typedCredentialGuidance(provider) {
    if (provider === 'achievers') {
        return {
            requiredFields: 'Program URL, client ID, and client secret',
            automaticSetup: 'Rocket derives the host and token URL, and requests a fresh access token when needed.',
        };
    }
    if (provider === 'workday') {
        return {
            requiredFields: 'Workday host, tenant, username, and password',
            automaticSetup: 'Rocket builds the tenant URL and SOAP endpoint automatically.',
        };
    }
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildProviderCredentials: buildProviderCredentials,
        buildSaveTypedCredentialsPayload: buildSaveTypedCredentialsPayload,
        buildTypedCredentialFields: buildTypedCredentialFields,
        typedCredentialGuidance: typedCredentialGuidance,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('typedCredentialFields', {
        buildProviderCredentials: buildProviderCredentials,
        buildSaveTypedCredentialsPayload: buildSaveTypedCredentialsPayload,
        buildTypedCredentialFields: buildTypedCredentialFields,
        typedCredentialGuidance: typedCredentialGuidance,
    });
}
